export default __webpack_public_path__ + "static/media/ice-cream.539f042c.svg";